// Données de démonstration de la page Performance marchés. Utilisées aussi par les tests des calculs.
import type { Marche } from './performanceMarches.calculs';

export const MARCHES_DEMO: Marche[] = [
  {
    id: '1',
    nom: 'Rénovation immeuble 15 rue de la Paix',
    acheteur: 'Ville de Paris',
    dateRemise: '2025-02-10',
    tonPrix: 125000,
    resultat: 'Perdu',
    prixGagnant: 98000,
    sourcePrixReference: 'estime',
    ecart: 27.6,
    notePrixObtenue: 8,
    notePrixMaximale: 10,
    modeNotation: 'inverse'
  },
  {
    id: '2',
    nom: 'Travaux de rénovation énergétique',
    acheteur: 'Département 93',
    dateRemise: '2025-03-05',
    tonPrix: 85000,
    resultat: 'Gagné',
    prixGagnant: 85000,
    ecart: 0
  },
  {
    id: '3',
    nom: 'Réhabilitation logements sociaux',
    acheteur: 'OPH Lyon',
    dateRemise: '2025-04-18',
    tonPrix: 92000,
    resultat: 'Perdu',
    prixGagnant: 74000,
    sourcePrixReference: 'estime',
    ecart: 24.3,
    notePrixObtenue: 7.5,
    notePrixMaximale: 10,
    modeNotation: 'inverse'
  },
  {
    id: '4',
    nom: 'Aménagement espace public',
    acheteur: 'Métropole Nantes',
    dateRemise: '2026-08-25',
    tonPrix: 45000,
    resultat: 'En attente'
  },
  {
    id: '5',
    nom: 'Construction école maternelle',
    acheteur: 'Commune de Tours',
    dateRemise: '2026-09-08',
    tonPrix: 180000,
    resultat: 'En attente'
  },
  {
    id: '6',
    nom: 'Construction crèche municipale',
    acheteur: 'Ville de Lyon',
    dateRemise: '2025-05-22',
    tonPrix: 150000,
    resultat: 'Gagné',
    prixGagnant: 150000,
    ecart: 0
  },
  {
    id: '7',
    nom: 'Extension collège Jean Moulin',
    acheteur: 'Département du Rhône',
    dateRemise: '2025-06-12',
    tonPrix: 210000,
    resultat: 'Perdu',
    prixGagnant: 193200,
    sourcePrixReference: 'estime',
    ecart: 8.7,
    notePrixObtenue: 9.2,
    notePrixMaximale: 10,
    modeNotation: 'inverse'
  },
  {
    id: '8',
    nom: 'Réfection voirie centre-ville',
    acheteur: 'Communauté de communes du Pilat',
    dateRemise: '2025-07-08',
    tonPrix: 65000,
    resultat: 'Gagné',
    prixGagnant: 65000,
    ecart: 0
  },
  {
    id: '9',
    nom: 'Rénovation gymnase Jean Jaurès',
    acheteur: 'Ville de Saint-Étienne',
    dateRemise: '2025-09-15',
    tonPrix: 98000,
    resultat: 'Perdu',
    prixGagnant: 70000,
    sourcePrixReference: 'estime',
    ecart: 40.0,
    notePrixObtenue: 6,
    notePrixMaximale: 10,
    modeNotation: 'subtractive'
  },
  {
    id: '10',
    nom: 'Aménagement parking relais',
    acheteur: 'Métropole de Lyon',
    dateRemise: '2025-10-20',
    tonPrix: 54000,
    resultat: 'Perdu',
    prixGagnant: 45900,
    sourcePrixReference: 'estime',
    ecart: 17.6,
    notePrixObtenue: 8.5,
    notePrixMaximale: 10,
    modeNotation: 'inverse'
  },
  {
    id: '11',
    nom: 'Construction médiathèque',
    acheteur: "Ville d'Annecy",
    dateRemise: '2026-09-15',
    tonPrix: 320000,
    resultat: 'En attente'
  },
  {
    id: '12',
    nom: 'Réhabilitation friche industrielle',
    acheteur: 'EPORA',
    dateRemise: '2025-11-14',
    tonPrix: 275000,
    resultat: 'Gagné',
    prixGagnant: 275000,
    ecart: 0
  },
  {
    id: '13',
    nom: 'Construction stade municipal',
    acheteur: 'Ville de Grenoble',
    dateRemise: '2026-01-19',
    tonPrix: 420000,
    resultat: 'Perdu',
    prixGagnant: 369600,
    sourcePrixReference: 'estime',
    ecart: 13.6,
    notePrixObtenue: 8.8,
    notePrixMaximale: 10,
    modeNotation: 'inverse'
  },
  {
    id: '14',
    nom: 'Réhabilitation toiture mairie',
    acheteur: 'Commune de Vienne',
    dateRemise: '2026-02-23',
    tonPrix: 38000,
    resultat: 'Perdu',
    prixGagnant: 36100,
    sourcePrixReference: 'estime',
    ecart: 5.3,
    notePrixObtenue: 9.5,
    notePrixMaximale: 10,
    modeNotation: 'inverse'
  },
  {
    id: '15',
    nom: 'Aménagement zone artisanale',
    acheteur: 'CC Vals du Dauphiné',
    dateRemise: '2026-03-30',
    tonPrix: 145000,
    resultat: 'Perdu',
    prixGagnant: 96667,
    sourcePrixReference: 'estime',
    ecart: 50.0,
    notePrixObtenue: 5,
    notePrixMaximale: 10,
    modeNotation: 'subtractive'
  },
  {
    id: '16',
    nom: 'Rénovation éclairage public',
    acheteur: 'Ville de Chambéry',
    dateRemise: '2026-05-11',
    tonPrix: 72000,
    resultat: 'Perdu',
    prixGagnant: 50400,
    sourcePrixReference: 'estime',
    ecart: 42.9,
    notePrixObtenue: 7,
    notePrixMaximale: 10,
    modeNotation: 'inverse'
  },
  {
    id: '17',
    nom: 'Construction centre technique municipal',
    acheteur: 'Ville de Valence',
    dateRemise: '2026-06-04',
    tonPrix: 195000,
    resultat: 'Gagné',
    prixGagnant: 195000,
    ecart: 0
  },
  {
    id: '18',
    nom: 'Réhabilitation école primaire',
    acheteur: 'Commune de Bourgoin-Jallieu',
    dateRemise: '2026-07-07',
    tonPrix: 88000,
    resultat: 'Gagné',
    prixGagnant: 88000,
    ecart: 0
  }
];
